import {
    DEALERWALLETEXCELPDFFILE_FAILED,
    DEALERWALLETEXCELPDFFILE_SUCCESS,
    RESET_DEALERWALLETEXCELPDFFILE,
    LOADING_DEALERWALLETEXCELPDFFILE,
    NETWORK_ERROR_DEALERWALLETEXCELPDFFILE

} from '../types/index';
const initialState = {
    isLoading: false,
    success: false,
    network: false,
    failed: false,
    data: {}
};
export default (state = initialState, action) => {
    switch (action.type) {
        case LOADING_DEALERWALLETEXCELPDFFILE:
            return {
                ...state,
                isLoading: true,
                success: false,
                failed: false,
                network: false,
                data: {}
            };
        case DEALERWALLETEXCELPDFFILE_FAILED:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: true,
                network: false,
                data: action.payload
            };
        case DEALERWALLETEXCELPDFFILE_SUCCESS:
            return {
                ...state,
                isLoading: false,
                success: true,
                failed: false,
                network: false,
                data: action.payload
            };
        case NETWORK_ERROR_DEALERWALLETEXCELPDFFILE:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: false,
                network: true,
                data: {}
            };
        case RESET_DEALERWALLETEXCELPDFFILE:
            return (state = initialState);
        default:
            return state;
    }
};